<div>
  <nav class="lib-nav">
    <ng-content></ng-content>
    <h6>Call history</h6>
    <div class="lib-badge">
      <span>{{callsCount}}</span>
    </div>
    <span class="lib-spacer-fixed"></span>
    <span class="lib-spacer"></span>
    <lib-button theme="flat-link" (click)="handleOutboundCallButtonClick()" [disabled]="working">
      Had an outbound call
    </lib-button>
  </nav>
  <lib-table [data]="data" [hidden]="!callsCount" (event)="onTableEvent($event)"></lib-table>
</div>